import { render, staticRenderFns } from "./crudProductsWeb.vue?vue&type=template&id=f36fc8c8&"
import script from "./crudProductsWeb.vue?vue&type=script&lang=js&"
export * from "./crudProductsWeb.vue?vue&type=script&lang=js&"
import style0 from "./crudProductsWeb.vue?vue&type=style&index=0&id=f36fc8c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports